import GuidanceListWrapper from '../components/GuidanceCuration/GuidanceList';
import GuidanceDeleteNotification from '../components/GuidanceCuration/GuidanceDeleteNotification';

const GUIDANCE_ROUTES = [
  {
    id: 'guidanceList',
    path: '/guidance',
    component: GuidanceListWrapper,
    exact: true
  },
  {
    id: 'guidanceNotification',
    path: '/guidance/notification',
    component: GuidanceDeleteNotification,
    exact: true
  }
];

export default GUIDANCE_ROUTES;
